import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const RoleSelector = ({ setActiveRole }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const user = JSON.parse(localStorage.getItem('user'));
  const roles = user?.roles || [user?.role];

  const handleSelect = (role) => {
    setActiveRole(role);
    localStorage.setItem('activeRole', role);
    navigate(role === 'teacher' ? '/teacher' : '/student-dashboard');
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white flex flex-col items-center justify-center space-y-6 px-4 text-center">
      <h2 className="text-2xl font-bold">{t('roles.select', 'Choose your role')}</h2>

      {roles.includes('student') && (
        <button
          onClick={() => handleSelect('student')}
          className="bg-green-600 hover:bg-green-700 px-6 py-2 rounded text-lg"
        >
          👨‍🎓 {t('roles.student', 'I’m a Student')}
        </button>
      )}

      {roles.includes('teacher') && (
        <button
          onClick={() => handleSelect('teacher')}
          className="bg-blue-600 hover:bg-blue-700 px-6 py-2 rounded text-lg"
        >
          👩‍🏫 {t('roles.teacher', 'I’m a Teacher')}
        </button>
      )}
    </div>
  );
};

export default RoleSelector;
